import React from 'react'
import LegalDepositsContextProvider from 'contexts/LegalDepositsContext'
import DepositsList from './DepositsList'

const Authority = (): JSX.Element => (
  <LegalDepositsContextProvider>
    <DepositsList />
  </LegalDepositsContextProvider>
)

export default Authority
